export default __webpack_public_path__ + "static/media/no_video.fb11b3a9.jpg";